<template>
    <div ref="slot">
        <slot></slot>
    </div>
    <vue-plyr ref="plyr">
        <div data-plyr-provider="youtube" :data-plyr-embed-id="source"></div>
    </vue-plyr>
</template>

<script>
export default {
    props: ['source', 'options'],
    mounted() {
        this.$refs.plyr.player.on('play', () => {
            this.$refs.slot.style.opacity = '0';
        });

        this.$refs.plyr.player.on('pause', () => {
            this.$refs.slot.style.opacity = '1';
        });
    },
    methods: {
        togglePlay() {
            this.$refs.plyr.player.togglePlay();
        }
    }
};
</script>
